import React, { useContext, useEffect, useState, useMemo } from 'react';

import { Table } from 'antd';
import { DragableBodyRow } from './DragableBodyRow';
import { DndContext, DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import './styles.less';

export const ReorderableTable = ( props ) => {
    const { columns = [], dataSource = [], components, reorderable = true, onRow, onReorder, ...otherProps } = props;
    const [ orderedData, setOrderedData ] = useState( [] );

    useEffect( () => {
        // Every time the original data source gets updated, overwrite all of the
        // ordered data to match the new data source.
        setOrderedData( dataSource );
    }, [ dataSource, setOrderedData ] );

    const handleRowDrop = ( dragIndex, hoverIndex ) => {
        const dragRow = orderedData[ dragIndex ];

        let dataCopy = [ ...orderedData ];
        dataCopy.splice( dragIndex, 1 );
        dataCopy.splice( hoverIndex, 0, dragRow );

        setOrderedData( dataCopy );

        // Execute the reorder callback if there is one provided.
        if ( onReorder ) {
            const dataKeys = dataCopy.map( data => data.key );
            onReorder( dataKeys, dataCopy );
        }
    };

    const canReorder = useMemo( () => {
        return ( reorderable && dataSource.length > 0 );
    }, [ dataSource, reorderable ] );

    // Reuse an ancestor DnD backend (hoisted to the app root) if one exists;
    // only mount our own when rendered standalone. react-dnd v11 throws
    // "Cannot have two HTML5 backends at the same time" if two mount at once.
    const { dragDropManager } = useContext( DndContext );

    const table = (
            <Table
                className="reorderable-table"
                columns={ columns }
                dataSource={ orderedData }
                components={ {
                    body: ( !canReorder ) ? {} : {
                        row: DragableBodyRow,
                    },
                    ...( components ? components : {} )
                } }
                onRow={ ( record, index ) => ( {
                    ...( !canReorder ? {} : {
                        index,
                        rowDrop: ( canReorder ) ? handleRowDrop : undefined,
                    } ),
                    ...( onRow ? onRow( record, index ) : {} )
                } ) }
                { ...otherProps }
            />
    );

    return dragDropManager ? table : <DndProvider backend={ HTML5Backend }>{ table }</DndProvider>;
};
